<template>
  <div>
    <main-layout>
      <v-container>
        <v-layout wrap>
          <v-flex sm6>
            <h1 class="mb-4">
              {{ $t('messenger_ads_simulator_json') }}
              <a href="https://blog.zwiz.ai/messenger-ads-simulator/" target="blank"
                ><i style="font-size: 22px; color: #ff706b" class="fas fa-question-circle"></i
              ></a>
            </h1>
          </v-flex>
          <v-flex sm6 class="text-xs-right">
            <v-btn outline color="primary" :loading="loadingAdd" @click="openLinkAds"
              >{{ $t('go_to_ads_manager') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <div>
          <div style="margin-bottom: 10px" class="broadcasts">
            <a
              v-show="!isShow"
              href="javascript:void(0);"
              @click="
                isShow = true
                adsItem = { quick_reply: '', a_val: [[]] }
              "
            >
              <div class="add-broadcast text-xs-center mb-2">
                <i class="fa fa-plus middle"></i>
                {{ $t('add_template_messenger_ads') }}
              </div>
            </a>

            <div v-if="isShow" class="intent-item z-border-red" style="padding: 10px 15px 0px">
              <form>
                <div class="form-control pa-1" :class="{ 'has-error': errors.has('name') }">
                  <label>{{ $t('name') }}</label>
                  <input
                    v-model="adsItem.message_name"
                    v-validate="'required'"
                    :data-vv-as="$t('name')"
                    name="name"
                    class="form-control"
                    type="text"
                  />
                  <span v-if="errors.has('name')" class="text-error">{{
                    errors.first('name')
                  }}</span>
                </div>
                <ads-simulator-preview
                  v-model="adsItem.a_val"
                  :quick-reply.sync="adsItem.quick_reply"
                ></ads-simulator-preview>
                <div class="text-xs-center mt-2 mb-2">
                  <v-btn outline color="grey" :loading="loadingAdd" @click="close"
                    >{{ $t('cancel') }}
                  </v-btn>
                  <v-btn depressed color="primary" :loading="loadingAdd" @click="saveIntentAds"
                    >{{ $t('Save') }}
                  </v-btn>
                </div>
              </form>
            </div>
          </div>

          <div
            v-show="!isShow"
            style="
              background: #ffffff 0% 0% no-repeat padding-box;
              border-radius: 26px;
              padding: 20px;
            "
          >
            <v-layout wrap>
              <v-flex xs12 sm6 class="form-control" style="display: inherit">
                <div class="input-icons">
                  <i class="fa fa-search icon"></i>
                  <input
                    v-model="search"
                    type="text"
                    class="form-control"
                    :placeholder="$t('search_ads_template_name')"
                    style="margin-bottom: 10px"
                    @keyup.enter="
                      pageNumber = 1
                      handleGetAdsSimulator()
                    "
                  />
                  <v-btn v-show="search.length > 0" icon class="icon-close" @click="clearSearch">
                    <i class="fa fa-close"></i
                  ></v-btn>
                </div>
                <v-btn
                  color="primary"
                  @click="
                    pageNumber = 1
                    handleGetAdsSimulator()
                  "
                >
                  {{ $t('Search') }}
                </v-btn>
              </v-flex>
              <v-flex v-if="pageLength > 1" xs12 sm6 class="text-xs-right">
                <v-pagination
                  v-model="pageNumber"
                  class="mb-2"
                  :total-visible="15"
                  :length="pageLength"
                  @input="changePage"
                ></v-pagination>
              </v-flex>
            </v-layout>
            <div v-if="loading" class="spinner text-xs-center mt-5">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
            <div
              v-for="(item, index) in data"
              v-else
              :key="index"
              class="intent-item z-border-red"
              style="padding: 10px 15px 10px"
            >
              <v-layout wrap>
                <v-flex xs12 sm6 class="pa-2">
                  <div class="primary--text">{{ item.message_name }}</div>
                </v-flex>
                <v-flex xs12 sm6 class="text-xs-right">
                  <v-btn
                    v-clipboard:copy="jsonMessagesAds(item.a_val, item.quick_reply)"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"
                    small
                    class="ma-1"
                    color="primary"
                  >
                    <v-icon class="mr-2">content_copy</v-icon>
                    {{ $t('copy_json') }}
                  </v-btn>
                  <v-btn
                    fab
                    outline
                    color="primary"
                    class="extra-small ma-1"
                    @click="editIntent(item)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </v-btn>
                  <v-btn
                    fab
                    outline
                    :loading="loadingDelete"
                    color="primary"
                    class="extra-small ma-1"
                    @click="handleDeleteAdsSimulator(item)"
                  >
                    <i class="fa fa-trash middle"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
              <div class="text-xs-right mt-3" @click="item.expand = !item.expand">
                <span
                  :class="{
                    'fas fa-chevron-down': !item.expand,
                    'fas fa-chevron-up': item.expand
                  }"
                  style="font-size: 1.5em; margin-right: 5px; cursor: pointer"
                  class="primary--text"
                ></span>
              </div>
              <ads-simulator-preview
                v-if="item.expand"
                v-model="item.a_val"
                :is-not-show-json="true"
                :is-only-json="true"
                :quick-reply.sync="item.quick_reply"
              ></ads-simulator-preview>
            </div>
            <div v-if="pageLength > 1 && !loading" class="text-xs-right mt-2">
              <v-pagination
                v-model="pageNumber"
                :total-visible="15"
                :length="pageLength"
                @input="handleChangePage"
              ></v-pagination>
            </div>
          </div>
        </div>
      </v-container>
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Copied') }}!
      </v-snackbar>
    </main-layout>
  </div>
</template>

<script>
import adsSimulatorApi from '@/api/ads-simulator'
import { mapGetters } from 'vuex'
import AdsSimulatorPreview from './AdsSimulatorPreview'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    AdsSimulatorPreview
  },
  data() {
    return {
      isShow: false,
      data: [],
      adsItem: { quick_reply: '', a_val: [[]] },
      loadingAdd: false,
      loading: false,
      loadingDelete: false,
      showCopy: false,
      pageTemp: 1,
      pageNumber: 1,
      limit: 10,
      offset: 0,
      search: '',
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    const vm = this
    if (
      ['ecommercebasic', 'tcp'].includes(vm.selectedBot.theme) ||
      vm.$store.state.shoptheme.includes(vm.selectedBot.theme)
    ) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
    }
    vm.$store.state.loadingSetting = false
    vm.handleGetAdsSimulator()
  },
  methods: {
    async close() {
      const vm = this
      vm.isShow = false
    },
    openLinkAds() {
      window.open('https://www.facebook.com/ads/manager/accounts', '_blank')
    },

    async handleGetAdsSimulator() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getAdsSimulator()
        vm.$store.dispatch('loading')

        if (
          response &&
          response.status == 200 &&
          response.data &&
          response.data.result &&
          response.data.message &&
          response.data.message == 'SUCCESS'
        ) {
          vm.data = []
          response.data.result.map((item) => {
            item.a_val = JSON.parse(item.a_val)
            item.expand = false
            vm.data.push(item)
          })

          vm.total = response.total
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },

    async getAdsSimulator() {
      const vm = this
      try {
        const data = {
          limit: vm.limit,
          offset: vm.offset,
          sort_type: 'desc',
          sort_by: 'message_name',
          search: vm.search || ''
        }
        vm.$store.dispatch('loading')
        const response = await adsSimulatorApi.getAdsSimulator({
          pageId: vm.selectedBot.pageid,
          config: data
        })
        vm.$store.dispatch('loading')
        handleResponse(response)

        if (response) {
          return response
        } else {
          throw new Error('response not found')
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        throw error
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetAdsSimulator()
      }
    },

    async createAdsSimulator(data) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await adsSimulatorApi.postAdsSimulator({
          pageId: vm.selectedBot.pageid,
          data: data
        })
        handleResponse(response)
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          throw new Error('response not found')
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        throw error
      }
    },

    async updateAdsSimulator(data, adsId) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await adsSimulatorApi.putAdsSimulator({
          pageId: vm.selectedBot.pageid,
          data,
          adsId
        })
        handleResponse(response)
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          throw new Error('response not found')
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        throw error
      }
    },

    async saveIntentAds() {
      const vm = this
      try {
        const resultValidate = await vm.$validator.validateAll()
        if (!resultValidate) return

        const data = {
          message_name: vm.adsItem.message_name,
          a_type: 'json',
          a_val: JSON.stringify(vm.adsItem.a_val),
          quick_reply: vm.adsItem.quick_reply || '',
          content_json: '[[]]'
        }

        vm.$store.dispatch('loading')
        let response = null
        if (vm.adsItem.id) {
          const adsId = vm.adsItem.id
          response = await vm.updateAdsSimulator(data, adsId)
        } else {
          response = await vm.createAdsSimulator(data)
        }
        vm.$store.dispatch('loading')

        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.message &&
          response.data.message == 'SUCCESS'
        ) {
          vm.isShow = false
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: `Ads ${vm.adsItem.message_name} ${
              vm.adsItem.id ? 'ถูกแก้ไขแล้ว' : 'ถูกเพิ่มแล้ว'
            }`,
            type: 'success'
          })

          vm.handleGetAdsSimulator()
        } else {
          if (response.data && response.data.message !== 'SUCCESS') {
            vm.$swal.fire({
              title: vm.$t('error'),
              text: vm.$t(response.data.message),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              reverseButtons: true
            })
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    editIntent(item) {
      const vm = this
      const setData = JSON.stringify(item)
      vm.adsItem = JSON.parse(setData)
      vm.isShow = true
    },
    async handleDeleteAdsSimulator(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: 'Ads ' + item.message_name
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteAdsSimulator(item.id)
          vm.$store.dispatch('loading')

          if (response && response.status === 200) {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Ads ${item.message_name} ถูกลบแล้ว`,
              type: 'success'
            })
            vm.handleGetAdsSimulator()
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async deleteAdsSimulator(id) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await adsSimulatorApi.deleteAdsSimulator({
          pageId: vm.selectedBot.pageid,
          adsId: id
        })
        handleResponse(response)
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          throw new Error('response not found')
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        throw error
      }
    },
    jsonMessagesAds(messages, quick_reply) {
      const vm = this
      let setMessages = JSON.stringify(messages[0])
      setMessages = JSON.parse(setMessages)
      let quick_replies = []
      let result = []
      setMessages.map((item) => {
        item.template_type = item.type
        item.elements = item.data
        delete item.type
        delete item.data
        delete item.altText
        if (item.buttons && item.buttons.length > 0) {
          item = vm.replaceShop(item.buttons)
        }
        if (item.elements && item.elements.length > 0) {
          item.elements.map((item) => {
            item = vm.replaceShop(item.buttons)
          })
        }

        if (quick_reply && quick_reply !== '') {
          quick_replies = quick_reply.split(',')
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {}
        }
      })

      let replies = JSON.stringify(result)
      replies = JSON.parse(replies)
      replies.map((item) => {
        item.title = item.text
        item.payload = item.text
        item.content_type = 'text'
        delete item.text
      })
      let json = {}
      if (setMessages[0] && setMessages[0].template_type === 'text') {
        json.message = { text: setMessages[0].text }
      } else if (
        setMessages[0] &&
        (setMessages[0].template_type === 'button' || setMessages[0].template_type === 'generic')
      ) {
        delete setMessages[0].custom_type
        json.message = {
          attachment: {
            type: 'template',
            payload: setMessages[0]
          }
        }
      } else if (setMessages[0] && setMessages[0].template_type === 'image') {
        json.message = {
          attachment: {
            type: 'image',
            payload: { url: setMessages[0].image_url }
          }
        }
      }

      if (json.message && replies.length > 0) {
        json.message['quick_replies'] = replies
      }

      return JSON.stringify(json, null, 4)
    },
    replaceShop(arrayData) {
      const vm = this
      if (arrayData && arrayData.length > 0) {
        arrayData.map((item) => {
          if (item && item.type !== 'postback') {
            item.url = item.url
              ? item.url.includes('{shopurl}')
                ? item.url.replace(
                    '{shopurl}',
                    `https://shopv2.zwiz.app/ecommerce/${vm.selectedBot.pageid}?`
                  )
                : item.url.replace(
                    '{salepage}',
                    `https://shopv2.zwiz.app/salepage/${vm.selectedBot.pageid}?`
                  )
              : ''
          }
        })
      }
      return arrayData
    },
    onCopy() {
      const vm = this
      vm.showCopy = true
    },
    onCopyError(error) {
      console.log(error)
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.handleGetAdsSimulator()
    }
  }
}
</script>
<style lang="scss" scoped>
.intentmax {
  font-size: 22px;
}

.input-icons {
  display: contents;

  i {
    position: absolute;
  }

  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }

  .icon {
    padding: 16px;
    min-width: 50px;
  }

  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/AdsSimulator/AdsSimulator.vue